import { render, staticRenderFns } from "./Milou.vue?vue&type=template&id=5bb7a449&scoped=true"
import script from "./Milou.vue?vue&type=script&lang=ts"
export * from "./Milou.vue?vue&type=script&lang=ts"
import style0 from "./Milou.vue?vue&type=style&index=0&id=5bb7a449&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7a449",
  null
  
)

export default component.exports